import { globals } from 'config'
import { universal } from 'database/db'
import { CurrentCountryType, CurrentLanguageType } from 'types'
import { dbCurrentEntries } from 'config/constants'
import { AppDataKeyEnum } from 'config/libs/globals'

const base64 = require('base-64')

export const getCurrentCountry = async (): Promise<CurrentCountryType> => {
  let currentCountry = globals.GET_APP_DATA(AppDataKeyEnum.currentCountry) as CurrentCountryType
  if (!currentCountry) {
    const country = await universal.dcaSettings.get(dbCurrentEntries.CURRENT_COUNTRY)
    currentCountry = country?.data ?? {}
  }
  return currentCountry
}

export const getCurrentLanguage = async (): Promise<CurrentLanguageType> => {
  let currentLanguage = globals.GET_APP_DATA(AppDataKeyEnum.currentLanguage) as CurrentLanguageType
  if (!currentLanguage) {
    const language = await universal.dcaSettings.get(dbCurrentEntries.CURRENT_LANGUAGE)
    currentLanguage = language?.data ?? {}
  }
  return currentLanguage
}

export const getAppLang = (activeLanguage: string) => {
  const validLanguages = ['ru', 'el', 'vi', 'uk', 'bg']
  return validLanguages.includes(activeLanguage) ? { lang: 'ru' } : {}
}

export function isObjectEmpty(obj: object | undefined): boolean {
  if (!obj || obj === null || obj === undefined) {
    return true
  }

  if (Object.keys(obj).length === 0) {
    return true
  }

  return false
}

/**
 * Do an image authentication to get the image from the new media server
 * @param imageUrl 
 * @returns 
 */
export async function imageAuthentication(imageUrl: string): Promise<string> {
  if (process.env.REACT_APP_DEPLOYMENT_ENV !== 'development' || !process.env.REACT_APP_NEW_MEDIA_URL) {
    return imageUrl
  }

  if (!imageUrl.includes(process.env.REACT_APP_NEW_MEDIA_URL)) {
    return imageUrl;
  }

  const url = new URL(imageUrl)
  const credentials = `${process.env.REACT_APP_MEDIA_USERNAME}:${process.env.REACT_APP_MEDIA_PASSWORD}`
  const authorization = `Basic ${base64.encode(credentials)}`

  const requestOptions: RequestInit = {
    method: 'GET',
    headers: {
      Authorization: authorization,
      'Accept-Encoding': 'gzip, deflate, br',
    },
    redirect: 'follow',
  }

  const response = await fetch(url.toString(), requestOptions)
  
  if (!response.ok) {
    return imageUrl
  }

  const blob = await response.blob()

  return URL.createObjectURL(blob)
}
